
import { PageConfig } from '@/utils/tool/Tool'
import { computed, defineComponent, reactive, Ref, ref, toRefs, watch } from 'vue'

export default defineComponent({
    props: {
        total: {
            type: Number,
            default: 0
        },
        onPageChange: {
            type: Function,
            default: () => () => {}
        }
    },
    setup(props) {
        const pageSize:number = PageConfig.PageSie
        const paginationSize:number = 6
        const curPage = ref<number>(1)
        const state = reactive({
            pageLine: [] as (number|string)[]
        })

        const getPageLine = () => {
            if (pageCount.value <= paginationSize) {
                const list = Array.from(new Array(pageCount.value).keys())
                return list.map(n => n+1)
            }
            let pageLine:(number|string)[] = []
            if (curPage.value - 1 > 1) {
                pageLine.push(curPage.value - 1)
            } 
            pageLine.push(curPage.value)
            if (curPage.value + 1 < pageCount.value) {
                pageLine.push(curPage.value + 1)
            }
            if (pageLine[0] > 2) {
                pageLine.unshift('...')
            }
            if (pageLine[0] != 1) {
                pageLine.unshift(1)
            }
            if (pageLine[pageLine.length - 1] < pageCount.value - 1) {
                pageLine.push('...')
            }
            if (pageLine[pageLine.length - 1] != pageCount.value) {
                pageLine.push(pageCount.value)
            }
            return pageLine
        }

        const pageCount:Ref<number> = computed(() => Math.ceil(props.total / pageSize))
        state.pageLine = getPageLine()
        watch(() => curPage.value, ()=> {
            state.pageLine = getPageLine()
            const startIndex = (curPage.value - 1)*pageSize
            const endIndex = startIndex + pageSize
            props.onPageChange && props.onPageChange(startIndex, endIndex)
        })

        watch(() => pageCount.value, () => {
            state.pageLine = getPageLine()
        })

        const toPre = () => {
            const pre:number = curPage.value - 1
            curPage.value = pre >= 1 ? pre : curPage.value
        }

        const toNext = () => {
            const next:number = curPage.value + 1
            curPage.value = next <=  pageCount.value ? next : curPage.value
        }

        const toJump = (to:string|number) => {
            if (typeof to === 'string') return 
            curPage.value = to >= 1 && to <= pageCount.value ? to : curPage.value
        }
        
        return {
            curPage,
            pageCount,
            pageSize,
            ...toRefs(state),
            toPre,
            toNext,
            toJump
        }
    }
})
